module.exports = __webpack_public_path__ + "assets/img/img1.68737b4a.png";